<template>
	<v-btn 
  		small 
  		color  = "success" 
  		@click = "exportExcel" 
   		v-text = "$ml.get('excel')" 
	></v-btn>  
</template>
<script type="text/javascript">
	import axios from 'axios'; 
	export default{
		name : "DownloadExcel",
		props : [ "info_search", "list_smart_events", "type_search", "reference"],
		data : ()=>({

		}),
		methods:{
			exportExcel () {	
				// console.log("CHEK INFO ", this.info_search)
		    	if (this.info_search && this.info_search.deviceId) {
				
			        this.$emit("receiveLoading",true);
			        let dates 		 	= this.info_search.dates;			
					let formated_dates 	= this.$Format.format_date_time(dates, this.info_search, true, false);
		    		let timeZone 		= this.$timezone;

				    let info 			= {		        	
				        deviceId 	  : this.info_search.deviceId, //.map(x => x.deviceId), //this.select_host,				        
				        start 		  : formated_dates.start,
				        end  		  : formated_dates.end,
				        timeZone,

				    };
				    let device_name = null ;
				    /*this.info_search && this.info_search.deviceId ? this.$Format.render_device(this.info_search.deviceId) : null ; 
				    if (device_name) {
				    	device_name = device_name.name
				    }*/				    				    
			        let url_ 	= '/api/v1/lpr/report';
			        if (this.reference == "avc") {
			        	url_ 				= '/api/v1/avc/report';
			        	info.vehicle_type 	= this.info_search.search;
			        
			        }else if (this.reference == "alarms") {
			        	if (this.type_search.type == "alarms") {
			     			url_ 			= '/api/v1/alerts/report';				    		
			        	}else{
			     			url_ 			= '/api/v1/smart_event/report';				    					        		
			        	}
			    	
			    	}else if(this.reference == "face"){
				    	url_ 				= '/api/v1/face/find/report';
			    	}
			    	else{
			        	if (this.reference == "parking") {
			        		url_ 			= '/api/v1/parking/report';
			        	}
				    	info.plate_char 	= this.info_search.search;				    
			        }
			        if (this.info_search.tags && this.info_search.tags.length > 0) {
			      		info.tags 		= [];
			      		info.rulesId 	= [];
			      		if (this.list_smart_events && this.list_smart_events.length > 0) {			      		
				      		this.list_smart_events.forEach(x => {
				      			if (x.id != 'all' && this.info_search.tags.includes(x.id)) {			      				
				      				info.tags.push(x.name);
				      				info.rulesId.push(x.id);
				      			}			      			
				      		});
			      		}
			      	}
			      	if (this.info_search.traineds && this.info_search.traineds.length > 0) {
			      		info.traineds = this.info_search.traineds; //.map(x => x.userId);
			      	}
			        const api 	= this.$URL + url_; 		
				    // console.log("Check reports ", api )

			        axios.post(api, info).then( response => {			        
			        	if (response && response.data && response.data.rows) {				        		
				          	let items 			= response.data.rows;				          				          	
				          	if (items && items.length > 0) {
				          		// console.log("ROWS Reports ALL ", items)
				          		const ref_name = this.type_search.type == "smart_event" ? "smart_event" : this.reference;

						        this.$Format.report_export_excel(ref_name, items, device_name, this.$Format, async (load) => {
						        	// console.log("LOAD ", load)
						       		this.$emit("receiveLoading", false);
						       		if (load && load.length > 0) {
						       			await this.$Format.export_excel_async(load, this.reference);
						       		}
						       })						      
						       	
					        }else{
					        	this.$EventBus.$emit('notifications_modal', {
			      					type 	: 'warning',
			      					message : this.$ml.get('data_no_found')
			      				});
			          			this.$emit("receiveLoading", false);
					        }
				          
			        	}else{
			          		this.$emit("receiveLoading", false);
			        	}
			        }).catch( error => {
			        	this.$emit("receiveLoading", false);
			        	console.log("Error get all lpr : ", error);
			        	this.$EventBus.$emit('notifications_modal', {
		      				type 	: 'error',
		      				message : error
		      			});

			        }) // axios
		        }else{
		      		console.log("Not found device to search");

		      		this.$EventBus.$emit('notifications_modal', {
		      			type 	: 'warning',
		      			message : this.$ml.get('req_sel_device')
		      		});
		      	}

		        
		    }, // exportExcel
		}
	}
</script>